import React from 'react';
import styled from 'styled-components';
import { Container, FullWidthCard } from '../../../components/Layout';
import PathwayCourse from './PathwayCourse';
import { Training } from '../models/training';
import { isCourse } from '../utils/isCourse';
import { isPathway } from '../utils/isPathway';
import CourseSteps from './CourseSteps';
import { NextAction } from '../models/nextAction';
import { UserTrainingAccess } from '../models/UserTrainingAccess';
import { Grid } from '../../../app/StyleGuide';

const CourseContentCard = styled(FullWidthCard)`
  margin: 0;
  flex: 1;
  padding: ${Grid._7} 0 ${Grid._10} 0;
`;

const FullWidthContainer = styled(Container)`
  width: 100%;
  max-width: 800px;
`;

const CourseContents = ({
  training,
  nextAction,
  userAccess,
}: {
  training: Training;
  nextAction?: NextAction;
  userAccess: UserTrainingAccess;
}) => {
  return (
    <CourseContentCard>
      <FullWidthContainer>
        <div>
          {isCourse(training) && (
            <CourseSteps course={training} trainingId={training.id} nextAction={nextAction} userAccess={userAccess} />
          )}
          {isPathway(training) &&
            training.entities
              .filter(e => e._type === 'TaskList')
              ?.map((c, i, arr) => {
                const course = c.taskList;
                const ownerName = training.owner === course?.owner ? training.ownerName : '';

                return (
                  course && (
                    <PathwayCourse
                      key={course?._id?.id}
                      course={course}
                      trainingId={training.id}
                      ownerName={ownerName}
                      index={i}
                      length={arr.length}
                      nextAction={nextAction}
                      userAccess={userAccess}
                    />
                  )
                );
              })}
        </div>
      </FullWidthContainer>
    </CourseContentCard>
  );
};

export default CourseContents;
